import { Editor, Element as SlateElement, Transforms, } from 'slate';
/** An empty slate document */
export const EmptyDocument = [
    {
        type: 'paragraph',
        children: [
            {
                text: '',
            },
        ],
    },
];
/** Toggle the passed in text format on the currently selected text node */
export function toggleMark(editor, format) {
    isMarkActive(editor, format)
        ? Editor.removeMark(editor, format)
        : Editor.addMark(editor, format, true);
}
/**
 * Check if the selected block matches the passed in format
 *
 * @param editor Instance of slate editor
 * @param format Format you want to check is active
 * @returns
 */
export function isBlockActive(editor, format) {
    const [match] = Editor.nodes(editor, {
        match: (n) => !Editor.isEditor(n) && SlateElement.isElement(n) && n.type === format,
    });
    return !!match;
}
/**
 * Checks if the text node has the passed format active
 *
 * @param editor Instance of slate editor
 * @param format Mark/text format you want to check
 * @returns
 */
export function isMarkActive(editor, format) {
    const marks = Editor.marks(editor);
    return marks ? marks[format] === true : false;
}
/**
 * Switch the current elment to the passed in format, acts as a toggle between
 * paragraph and heading-two
 *
 * @param editor Instance of slate editor
 * @param format
 */
export function toggleBlock(editor, format) {
    const isActive = isBlockActive(editor, format);
    const newProperties = {
        type: isActive ? 'paragraph' : format,
    };
    Transforms.setNodes(editor, newProperties);
}
